import {
    CardActions,
    CardHeader,
    Button,
    Container,
    Card,
    CardContent,
    Typography,
    Box,
    Grid, useTheme
} from "@mui/material";
import {useTranslation} from "react-i18next";
import {tokens} from "../theme.ts";

const Upgrade = () => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette);

    return (
        <Container sx={{ display: 'flex', height: "100%", justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <Box maxWidth={"xs"} sx={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <Card sx={{flex: 1, borderRadius: 4, p: 2, justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
                    <CardHeader title={t('upgrade.title')} sx={{textAlign: 'center'}}/>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid size={{xs: 12}}>
                                <Typography>
                                    {t("upgrade.info")}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <CardActions sx={{display: 'flex', justifyContent: 'center'}}>
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{marginTop: 2, backgroundColor: colors.primary[500], color: 'white'}}
                            onClick={()=> window.open("https://staging.d124igdz4ne463.amplifyapp.com/")}
                        >
                            {t("upgrade.button")}
                        </Button>
                    </CardActions>
                </Card>
            </Box>
        </Container>
    );
};

export default Upgrade;
